// import { AuthenticationAuthService } from "../api";
import { UsersService, UserBaseOut, UserBasicDetailsOut } from "../api";



export async function getCurrentUser(): Promise<UserBaseOut> {
  const response = await UsersService.getProfileUsersMeGet();
  return response;
}

export async function getCurrentUserBasic(): Promise<UserBasicDetailsOut> {
  const response = await UsersService.getUserBasicDataUsersMeBasicGet();
  return response;
}


export const logout = () => {
  localStorage.removeItem("token");
};